import { render } from "./ChurchProfile.vue?vue&type=template&id=2ce60152&scoped=true"
import script from "./ChurchProfile.vue?vue&type=script&lang=js"
export * from "./ChurchProfile.vue?vue&type=script&lang=js"

import "./ChurchProfile.vue?vue&type=style&index=0&id=2ce60152&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ce60152"]])

export default __exports__